import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { SkeletonMarqueeComponent } from './skeleton-marquee.component';

@Component({
    selector: 'ms-skeleton-events',
    templateUrl: './skeleton-events.component.html',
    imports: [NgClass, SkeletonMarqueeComponent],
})
export class SkeletonEventsComponent {
    device = inject(DeviceService);

    private readonly ids = [1, 4, 5, 8, 9];
    private readonly mIds = [1, 3, 5, 7, 9];

    getEventOrderId(id: number): boolean {
        if (this.device.isMobile && !this.device.isTablet) {
            return this.mIds.some((x) => x === id);
        }

        return this.ids.some((x) => x === id);
    }
}
